import React, {useCallback} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {
  updatePaginatorStatus,
  userReviewDetailType,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-actions';
import {
  reviewDetailTypeSelector,
  rnrPaginatorStatus,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';

import DropDownCheckList from '../../SRP/DropDownCheckList/DropDownCheckList';

//CONFIG
import {
  DEFAULT_RNR_OFFSET,
  DEFAULT_RNR_LIMIT,
  DEFAULT_RNR_SORTBY,
  DEFAULT_SORTBY_TEXT,
} from '@stencil/hotels-ugc-redux/src/ugc-config';

//GA Events
import {pushga} from 'ga-utils';
import {gaConfig} from '@stencil/hotels-config';
const {DetailPageGAEvents} = gaConfig;

const sortOptions = [
  {name: 'Most Helpful First', group: 'sortby', value: 'help', checked: true},
  {name: 'Most Recent First', group: 'sortby', value: 'rec'},
  {name: 'Most Favourable First', group: 'sortby', value: 'fav'},
  {name: 'Most Critical First', group: 'sortby', value: 'cri'},
];

const RnrSorting = () => {
  const reviewDetailType = useSelector(reviewDetailTypeSelector, shallowEqual);
  const paginatorStatus = useSelector(rnrPaginatorStatus, shallowEqual);

  const dispatch = useDispatch();
  const {tagIds, filter} = reviewDetailType;

  const updateReviewDetail = useCallback(
    detailType => {
      return dispatch(userReviewDetailType(detailType));
    },
    [reviewDetailType],
  );

  const updatePaginationStatus = useCallback(
    status => {
      return dispatch(updatePaginatorStatus(status));
    },
    [paginatorStatus],
  );

  const onHandleChange = (value, name) => {
    updatePaginationStatus(paginatorStatus.concat(value));
    updateReviewDetail({
      offset: DEFAULT_RNR_OFFSET,
      limit: DEFAULT_RNR_LIMIT,
      tagIds: tagIds,
      filter: filter,
      sortBy: value,
    });
    pushga({
      eventCategory: DetailPageGAEvents.reviewConsumptionCategory,
      eventAction: DetailPageGAEvents.sortClicked,
      eventLabel: name,
    });
  };

  return (
    <>
      <DropDownCheckList
        options={sortOptions}
        onHandleChange={onHandleChange}
        title={'Sort By'}
        selOption={DEFAULT_RNR_SORTBY}
        selOptionName={DEFAULT_SORTBY_TEXT}
        dataTestIdForTitle={'SortByTitle'}
        dataTestIdForOptions={'SortByOptions'}
      />
    </>
  );
};

export default RnrSorting;
